/* ============================================================
   SCROLL REVEAL — paired with professional-polish.css
   Adds gentle fade-up animations to sections as they enter view.
   Tags applied automatically; no template edits required.
   ============================================================ */
(function () {
  "use strict";

  if (typeof window === "undefined" || typeof document === "undefined") return;

  // Respect users who don't want motion
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  // Selectors we want to fade in. Kept conservative to avoid flicker.
  var revealSelectors = [
    ".index-section > .page-width > *",
    ".section-header",
    ".product-card",
    ".grid-view-item",
    ".collection-grid-item",
    ".feature-row",
    ".feature-row__item",
    ".quotes-wrapper .grid__item",
    ".rich-text",
    ".image-bar__content",
    ".newsletter-section__wrapper",
    ".collection-hero",
    ".product-single__media",
    ".product-single__meta",
    /* GemPages-built blocks */
    ".gp-component",
    ".gp-section",
    ".gp-row",
    ".gp-product-item"
  ];

  function tagForReveal() {
    var selector = revealSelectors.join(",");
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute("data-pp-reveal")) continue;
      // Skip if inside a slideshow/carousel — those have their own anims
      if (el.closest(".slick-slide, .swiper-slide, .slideshow__slide")) continue;
      el.setAttribute("data-pp-reveal", "");
    }
  }

  function reveal() {
    if (!("IntersectionObserver" in window)) {
      // Fallback: just show everything
      var all = document.querySelectorAll("[data-pp-reveal]");
      for (var i = 0; i < all.length; i++) all[i].classList.add("pp-revealed");
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            // Gentle stagger for items revealed in same batch
            var delay = Math.min(index * 60, 240);
            setTimeout(function () {
              entry.target.classList.add("pp-revealed");
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.08
      }
    );

    var targets = document.querySelectorAll("[data-pp-reveal]");
    for (var i = 0; i < targets.length; i++) observer.observe(targets[i]);
  }

  function init() {
    tagForReveal();
    reveal();

    // Re-scan on dynamic content changes (Shopify sections, GemPages re-render, AJAX)
    if ("MutationObserver" in window) {
      var mo = new MutationObserver(function () {
        tagForReveal();
        reveal();
      });
      mo.observe(document.body, { childList: true, subtree: true });
      // Stop observing after 8s to avoid perf overhead
      setTimeout(function () {
        mo.disconnect();
      }, 8000);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
